import React, { useRef, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => setMenuOpen(false);

    return (
        <>
            <nav className="navbar navbar-expand-lg custom-navbar">
                <div className="container-xl d-flex justify-content-between align-items-center">

                    <div className="d-flex align-items-center justify-content-between w-100">
                        <NavLink className="navbar-brand d-flex gap-3 align-items-center logo-section" to="/" onClick={closeMenu}>
                            <img
                                src="/assets/imgs/logo.png"
                                alt="JJ Associates Logo"
                                className="navbar-logo"
                            />
                            <h2 className="logo-title mb-0">JJ Associates</h2>
                        </NavLink>

                        {/* Toggler for mobile */}
                        <button
                            className="navbar-toggler custom-toggler"
                            type="button"
                            aria-label="Toggle navigation"
                            onClick={toggleMenu}
                        >
                            {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                        </button>
                    </div>

                    <div className={`collapse navbar-collapse justify-content-end ${menuOpen ? 'show' : ''}`} id="navbarSupportedContent">
                        <ul className="navbar-nav align-items-center">
                            {[
                                { to: '/', label: 'Home' },
                                { to: '/about', label: 'About Us' }
                            ].map(({ to, label }) => (
                                <li key={to} className="nav-item">
                                    <NavLink
                                        to={to}
                                        end={to === '/'} // exact match for Home
                                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                        onClick={closeMenu}
                                    >
                                        {label}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            </nav>
            <hr />
        </>
    )
}

export default Navbar